import React from "react";
import { Link } from "react-router-dom";

const EmptyState = () => (
  <tbody>
    <tr>
      <td colSpan={4} style={{ textAlign: "center", padding: "2rem" }}>
        <div style={{ display: "inline-block" }}>
          <h3>No files or directory found</h3>
          <p style={{ marginTop: "0.5rem", marginBottom: "1.5rem" }}>
            The directory you're looking for doesn't exist or is empty.
          </p>
          <Link
            to="/"
            style={{
              display: "inline-block",
              padding: "0.5rem 1rem",
              backgroundColor: "#748EAA",
              color: "#fff",
              borderRadius: "4px",
              textDecoration: "none"
            }}
          >
            ⬅️ Back to Home
          </Link>
        </div>
      </td>
    </tr>
  </tbody>
);

export default EmptyState;
